export const RECEIPT_STATUS_OPTIONS = [
  { value: 'RECEIVED', label: '접수' },
  { value: 'IN_PROGRESS', label: '처리중' },
  { value: 'COMPLETED', label: '완료' },
  { value: 'REJECTED', label: '반려' },
];

export const SEARCH_TYPE_OPTIONS = [
  { value: 'INSTALLATION_COMPANY', label: '시공사' },
  { value: 'PROPOSER', label: '민원인' },
  { value: 'PROCESSED_BY', label: '조치자' },
];
